var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgLeftRoundActive = function SvgLeftRoundActive(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 512 512",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.26953,0,0,1.26953,-106.743,-76.6267)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 285.126,
    cy: 260.599,
    r: 196.216,
    style: {
      fill: "rgb(95,185,97)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M256,0C114.401,0 0,114.269 0,256C0,397.731 114.269,512 256,512C397.731,512 512,397.731 512,256C512,114.269 397.601,0 256,0ZM256,477.771C133.14,477.771 34.228,378.859 34.228,255.999C34.228,133.139 133.141,34.227 256,34.227C378.859,34.227 477.772,133.139 477.772,255.999C477.772,378.859 378.86,477.771 256,477.771Z",
    style: {
      fill: "rgb(95,185,97)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.776,254.308L298.688,155.397C305.455,148.498 305.455,138.217 298.688,131.45C291.921,124.682 281.638,124.682 274.741,131.45L163.855,242.335C160.471,245.72 158.78,249.103 158.78,254.309C158.78,259.385 160.471,262.898 163.855,266.283L276.433,378.861C279.817,382.245 283.2,383.937 288.407,383.937C291.791,383.937 296.997,382.245 298.688,377.169C305.455,370.402 305.455,360.121 298.688,353.222L199.776,254.308Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLeftRoundActive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/left-round-active.9077bdb2.svg";
export { ForwardRef as ReactComponent };